import * as Yup from 'yup';

const schema = Yup.object().shape({
  Nome: Yup.string().required('O campo deve ser preenchido'),
  EmailAlternativo: Yup.string()
    .email('Digite um endereço de email válido')
    .nullable(),
  Telefone: Yup.string()
    .required('O campo deve ser preenchido')
    .min(14, 'Digite um telefone válido')
    .max(15, 'Digite um telefone válido'),
  Faculdade: Yup.string().nullable(),
});

export default schema;
